type TRPCErrorWithStatus = {
  meta?: {
    response?: {
      status?: number;
    };
  };
};

export function getTRPCErrorStatus(error: unknown): number | undefined {
  return (error as TRPCErrorWithStatus)?.meta?.response?.status;
}
